import script from "./StickyAudioplayerPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./StickyAudioplayerPanel.vue?vue&type=script&setup=true&lang=js"

import "./StickyAudioplayerPanel.vue?vue&type=style&index=0&id=46e89117&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46e89117"]])

export default __exports__